<!--
* @description  参数1
* @fileName  actionIndex
* @author userName
* @date 2024-01-19 15:53:28
!-->
<template>
  <div>
    <div id="actionIndex" class="actionIndex">
      <div class="card-bg">
        <div>Your shipment is almost ready to go!</div>
        <div>Fill in the required information below so we provider can process your shipment.</div>
      </div>
      <div class="card-default">
        <div class="card-l">
          <img src="../../../../../../assets/img/client/booking/icon1.png" width="24px" height="24px">
          <span>Door To Door</span><span class="m8">|</span>
          <span>{{ data.startCityNameEn }}, {{ data.startCountryNameEn }}</span> >
          <span>{{ data.destCityNameEn }}, {{ data.destProvinceNameEn }},
            {{ data.destCountryNameEn }}</span>
        </div>
        <div class="card-r" @click="cancelShip">Cancel shipment</div>
      </div>
    </div>
    <div class="group-main">
      <div class="group-main-aside">
        <ByFold :list="menuList" @getActive="getActive" @isOpen="isOpen" />
      </div>
      <div>
        <BillingDetails
          v-if="activeName=='Payment method'"
          ref="BillingDetails"
          @finish="finish"
          @next="next"
        />
        <ContactIndex
          v-if="showContact"
          ref="ContactIndex"
          :active-name="activeName"
          @finish="finish"
          @next="next"
        />
        <Commodities
          v-if="activeName=='Commodities'"
          ref="Commodities"
          :active-name="activeName"
          @finish="finish"
          @next="next"
        />
        <Invoice
          v-if="activeName=='Upload documents'"
          ref="Invoice"
          :active-name="activeName"
          @finish="finish"
          @next="next"
        />
      </div>
    </div>
    <CancelShipment ref="cancelShip" @confirm="finish" />
  </div>
</template>

<script>
import ByFold from '../../../../../../components/byFold/byFold.vue'
import BillingDetails from './billingDetails.vue'
import ContactIndex from './contactDetails/contactIndex.vue'
import Commodities from './yourGoods/commodities.vue'
import Invoice from './yourGoods/invoice.vue'
import CancelShipment from './cancelShipment.vue'
import {
  CheckOrderCompleteDetail
} from '@/api/order.js'
export default {
  name: 'ActionIndex',
  components: {
    ByFold,
    BillingDetails,
    ContactIndex,
    Commodities,
    Invoice,
    CancelShipment
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      menuList: [{
        name: 'Payments',
        isTrue: false,
        child: [{
          name: 'Payment method',
          isActive: false
        }]
      },
      {
        name: 'Contact details',
        isTrue: false,
        child: [{
          name: 'Pickup',
          isActive: false
        },
        {
          name: 'Consignor',
          isActive: false
        },
        {
          name: 'Delivery',
          isActive: false
        },
        {
          name: 'Consignee',
          isActive: false
        }
        ]
      },
      {
        name: 'Your Goods',
        isTrue: false,
        child: [{
          name: 'Commodities',
          isActive: false
        },
        {
          name: 'Upload documents',
          isActive: false
        }
        ]
      }
      ],
      data: {},
      activeName: '',
      isCancelDialog: false
    }
  },
  computed: {
    // 计算属性
    showContact() {
      return ['Pickup', 'Consignor', 'Delivery', 'Consignee'].some(
        (item) => this.activeName == item
      )
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    next(stepName, index) {
      this.activeName = stepName
      this.getActive({
        name: stepName,
        isActive: false
      }, index)
      this.menuList.forEach((item, index) => {
        item.child.forEach((item1, index1) => {
          if (item1.name === stepName) {
            this.isOpen(item, index)
            this.getActive(item1, index1)
          }
        })
      })
      this.checkOrder()
    },
    checkOrder() {
      CheckOrderCompleteDetail(this.data.orderNo).then(res => {
        if (res.code === 200) {
          var completeList = res.data.completeList
          var incompleteList = res.data.incompleteList
          completeList.forEach(stepName => {
            this.menuList.forEach((item, index) => {
              item.child.forEach((item1, index1) => {
                if (item1.name === stepName) {
                  item1.isFinish = true
                }
              })
            })
          })
          incompleteList.forEach(stepName => {
            this.menuList.forEach((item, index) => {
              item.child.forEach((item1, index1) => {
                if (item1.name === stepName) {
                  item1.isFinish = false
                }
              })
            })
          })
        }
      })
    },
    init(data) {
      this.data = data
      this.checkOrder()
    },
    finish() {
      this.$emit('finish')
    },
    cancelShip() {
      this.$refs.cancelShip.init(this.data)
    },
    // 方法
    isOpen(item, index) {
      this.menuList.forEach((res, i) => {
        if (index == i) {
          this.$set(res, 'isTrue', true)
        } else {
          this.$set(res, 'isTrue', false)
        }
      })
    },
    getActive(item, index) {
      this.activeName = item.name
      if (this.activeName === 'Payment method') {
        this.$nextTick(() => {
          this.$refs.BillingDetails.init(this.data)
        })
      }
      if (['Pickup', 'Consignor', 'Delivery', 'Consignee'].some((item) => this.activeName == item)) {
        this.$nextTick(() => {
          this.$refs.ContactIndex.init(this.data, index)
        })
      }
      if (this.activeName === 'Commodities') {
        this.$nextTick(() => {
          this.$refs.Commodities.init(this.data)
        })
      }
      if (this.activeName === 'Upload documents') {
        this.$nextTick(() => {
          this.$refs.Invoice.init(this.data)
        })
      }
      this.menuList.forEach(res => {
        res.child.forEach((list, j) => {
          if (index == j) {
            this.$set(list, 'isActive', true)
          } else {
            this.$set(list, 'isActive', false)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.confirmOrder-title-font {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.actionIndex {
		width: 1168px;
		height: 140px;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 16px;
		margin-top: 16px;

		.card-bg {
			display: block;
			text-align: center;
			width: 1168px;
			height: 56px;
			background: url("../../../../../../assets/img/client/booking/bg_xiadan.png");
			background-size: 1168px 100px;
			padding: 22px 0;

			div:nth-of-type(1) {
				@extend .confirmOrder-title-font;
				margin-bottom: 11px;
			}

			div:nth-of-type(2) {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;
			}
		}

		.card-default {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 17px 0;

			.card-l {
				display: flex;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;

				img {
					margin-right: 8px;
				}
			}

			.card-r {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				cursor: pointer;
			}
		}

	}

	.group-main {
		display: flex;
		margin: 16px 0;

		.group-main-aside {
			width: 180px;
			height: auto;
			border-radius: 8px;
			background: rgba(216, 216, 216, 0);
			margin-right: 24px;
		}
	}
</style>
